import React from "react";
import "../../styles/CaseStudyOne/CaseStudiesCallout.css";
import productIcon1 from "../../assets/ai-bot.png";
import productIcon2 from "../../assets/ai-object.png";
import productIcon3 from "../../assets/purple-a.png";
import { Link } from 'react-router-dom';

const CaseStudiesCallout = () => {
  return (
    <section className="case-callout-section">
      <div className="case-callout-container">
        {/* Title */}
        <h2 className="case-callout-title">Ready to Make Your Case Study?</h2>

        {/* Description Text */}
        <p className="case-callout-description">
            Let our team handle your toughest marketing challenges while you handle how to maintain growth with our scalable solutions and services.
        </p>

        {/* Product/Service Boxes */}
        <div className="case-callout-product-container">
          <div className="case-callout-box">
            <img
              src={productIcon1}
              alt="Product/Service Callout 1"
              className="case-callout-icon"
            />
            <p>Call Tracking Metrics Integration</p>
          </div>
          <div className="case-callout-box">
            <img
              src={productIcon2}
              alt="Product/Service Callout 2"
              className="case-callout-icon"
            />
            <p>AI-Powered Campaign Optimization</p>
          </div>
          <div className="case-callout-box">
            <img
              src={productIcon3}
              alt="Product/Service Callout 3"
              className="case-callout-icon"
            />
            <p>Google Ads Strategy and Results</p>
          </div>
        </div>
      </div>

      {/* CTA Below Cards */}
      <div className="case-callout-cta">
        <p className="case-callout-cta-text">Click below to Schedule Your FREE Growth Audit!</p>
        <Link to="/lead-form" className="case-callout-cta-button">Get Your Growth Audit</Link>
      </div>

    </section>
  );
};

export default CaseStudiesCallout;
